<button
  *ngIf="userData"
  cssClass="e-avatar-dropdown d-flex align-items-center"
  ejs-dropdownbutton
  [items]='items'
  (select)='select($event)'
>
  <medrecord-ui-avatar [link]="userData.photoBase64Data | base64String : userData.photoContentType"></medrecord-ui-avatar>
  <span class="ml-2">{{ userData.name?.firstName }}</span>
</button>